module.exports = __webpack_public_path__ + "img/sbg0105.5c0fb60e.png";